//------------------------------------------------------------------------------
// BFA10103G 共架申込 機器設備 - 地図/設備描画
//------------------------------------------------------------------------------
import Point from '@arcgis/core/geometry/Point';
import Graphic from '@arcgis/core/Graphic';
import PictureMarkerSymbol from '@arcgis/core/symbols/PictureMarkerSymbol';
import PoleItem from '@/utils/pole-item';

// 定数
const LOGH = 'BFA10103G draw setubi:';

/**
 * 設備一覧描画
 */
export function drawSetubi(layer, template, orderPoles) {
  if (!layer) return;

  // 電柱一覧描画
  const graphics = Array.from(orderPoles.values())
      .filter((pole) => pole.drawable())
      .map((pole) => setubiGraphic(pole, template));
  layer.removeAll();
  layer.addMany(graphics);
  console.debug(LOGH, `grpahics=${graphics.length}`);
}

// 設備アイコン
const SETUBI_ICON = new PictureMarkerSymbol({
  url: '/icons/square-red.svg',
  width: '24px',
  height: '24px',
});

/**
 * 設備グラフィック作成
 */
function setubiGraphic(pole, template) {

  // 座標
  const point = new Point({
    latitude: pole.latitude,
    longitude: pole.longitude,
  });

  // 属性
  const attributes = {
    type: 'setubi',
    pole: pole,
  };

  // グラフィック作成
  return new Graphic({
    symbol: SETUBI_ICON,
    geometry: point,
    attributes: attributes,
    popupTemplate: template,
  });
}
